import api from "@/core/services/api.service";

class credentialError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const CredentialService = {

    async loadAthleteOfficers(params){
        try {
            api.setHeader();
            const response = await api.post("acr/credentials", params);
            return response;
        } catch (error) {
            throw new credentialError(error.response.status, error.response)
        }
    }
}

export default CredentialService
export { CredentialService, credentialError }